import React, { useState } from "react";
import { shopApi } from "../../context/ShopAuthContext";
import { BookingForm } from "../agent-core/BookingForm";
import { OriginFields, originDefaults, OPS } from "./common";

export const ShipmentCreate=({onSaved,onCancel})=>{
  const [origin,setOrigin]=useState(originDefaults),[key]=useState(()=>crypto.randomUUID());
  const submit=async body=>(await shopApi.post(`${OPS}/shipments`,{...body,...origin},{headers:{"Idempotency-Key":key}})).data;
  return <div data-testid="agent-shipment-create-form"><OriginFields value={origin} onChange={setOrigin}/><BookingForm title="Nieuwe zending" submitLabel="Zending aanmaken" submitOverride={submit} onSaved={onSaved} onCancel={onCancel}/></div>;
};